import { ContainerEnvironment, Text } from './styles'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function ShowEnvironmentNotReleased(props) {
  return process.env.REACT_APP_ENVIRONMENT !== 'production' ? (
    <>
      <ContainerEnvironment>
        <div>
          <Text>
            Esta é uma versão de homologação, para acessar a plataforma por
            favor
          </Text>
          <a
            style={{ textDecoration: 'none' }}
            href="https://frotista.sotran.com.br/"
          >
            {' '}
            <Text style={{ textDecoration: 'underline' }}>clique aqui</Text>
          </a>
        </div>
      </ContainerEnvironment>
      {props.children}
    </>
  ) : (
    props.children
  )
}

export { ShowEnvironmentNotReleased }
